


















import { ref, defineComponent, inject } from '@vue/composition-api'

import TextbookIssueForm from './TextbookIssueForm.vue'
import CloseButton from '@/components/custom/CloseButton.vue'
import { createTextbookIssue } from '@/shared/api'
import { alertSymbol } from '@/shared/state-management/symbols'

export default defineComponent({
  name: 'CreateTextbookIssue',
  components: {
    TextbookIssueForm,
    CloseButton,
  },
  props: {
    textbook: Object,
  },
  setup(props, context) {
    const loading = ref(false)
    const $alert = inject(alertSymbol) as Function

    const submit = async (formData: Record<string, string>) => {
      loading.value = true
      try {
        const createdTextbookIssue = await createTextbookIssue(formData)
        context.emit('textbook-issue-created', createdTextbookIssue)
        $alert({
          text: context.root.$t('textbookIssue.created'),
          type: 'success',
        })
        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    return {
      loading,
      submit,
    }
  },
})
